import { Component, Input, inject } from '@angular/core';
import { Router } from '@angular/router';
import { QUESTION_STATUS_LABELS, QuestionStatus } from '../../models/question.model';
import { TopQuestionItem } from '../../models/insights-dashboard.model';

@Component({
    selector: 'app-ask-ayen-recent-activity',
    templateUrl: './recent-activity.component.html',
    styleUrl: './recent-activity.component.scss',
    standalone: false
})
export class RecentActivityComponent {
  @Input() questions: TopQuestionItem[] = [];

  private router = inject(Router);

  goToQuestions(): void {
    this.router.navigate(['/pages/ask-ayen/questions']);
  }

  get rows() {
    return this.questions.map((item) => ({
      question: item.content,
      specialty: item.specialization__name_ar || 'غير محدد',
      expert: item.first_expert_first_name
        ? `${item.first_expert_first_name} ${item.first_expert_last_name ?? ''}`.trim()
        : 'غير معيّن',
      replies: item.answers_count,
      isOpen: item.status === QuestionStatus.Open,
      statusLabel: QUESTION_STATUS_LABELS[item.status as QuestionStatus] ?? item.status,
    }));
  }
}
